import { Auth } from 'aws-amplify';

const environment = {
    production: true,
    debug: false,
    offline: false,
    cloudformationLaunchStackUrl: 'https://console.aws.amazon.com/cloudformation/home?region=eu-west-1#/stacks/create/review?stackName=VizCon&templateURL=https://vizcon-resources-prod.s3.amazonaws.com/iac/latest/crossAccountAccessRole.yml',
    cloudformationTemplateUrl: 'https://resources.vizcon.cloud/iac/latest/crossAccountAccessRole.yml',
    cognitoSelfSignUpEnabled: false, // Enterprise - self-signup disabled
    Amplify: {
        Auth: {
            region: 'eu-west-1', // To be updated after Terraform deployment if different region
            userPoolId: 'eu-west-1_dX8f5VNLS',  // To be updated after Terraform deployment
            userPoolWebClientId: '5i4m2b76u2fg2p7adomeoscum9',   // To be updated after Terraform deployment
        },
        API: {
            endpoints: [
                {
                    name: 'VizConAPI',
                    endpoint: 'https://vizcon-api.rtp-exp.xp2cloud.fr',  // To be updated with actual API domain
                    custom_header: async () => {
                        return { Authorization: (await Auth.currentSession()).getIdToken().getJwtToken() };
                    }
                }
            ]
        }
    },
    features: {
        subscriptions: false,  // Disabled for enterprise deployment
        userInvitation: false
    },
    stripe: {
        enabled: false,  // Disabled for enterprise deployment
        "redirectUrl": ""
    },
    aws: {
        enabled: false,  // Disabled for enterprise deployment
        marketplaceUrl: "",  // Disabled for enterprise deployment
        subscriptionManagementUrl: "",  // Disabled for enterprise deployment
        productCode: "",  // Disabled for enterprise deployment (Lifetime product code)
        productCodeSubscription: ""  // Disabled for enterprise deployment (Subscription product code)
    },
    defaultRoleName: "VizConRole",  // Matches terraform.tfvars default_cross_account_role_name
    matomo: {
        enabled: false,  // Disabled for enterprise deployment
        containerUrl: ""
    },
    branding: {
        logoPath: "assets/img/logo/vizcon-logo.png",
        logoAlt: "VizCon Logo",
        companyName: "VizCon"
    },
    license: {
        expiryDate: null,  // Optional: ISO date string (e.g., "2024-12-31T23:59:59Z") for POC/trial licenses
        warningDays: 7     // Show warning X days before expiry
    }
};

export default environment;
